import { useState, useEffect } from "react";
import axios from "axios";
import Banner from "../../components/Banner";
import Header from "../../components/Header";
import CTASection from "../../components/CTASection";
import Footer from "../../components/Footer";
import NewsCard from "../../components/NewsCard";
import backgroundImage from "../../img/banner/ZTO-Banner.png";
import newsImage1 from "../../img/default-image.jpg";
import { Link } from "react-router-dom";
import { IoSearchSharp } from "react-icons/io5";
import "../../css/news.css";
import { API_URL_All } from "../../api";

const SourceNews = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [newsData, setNewsData] = useState([]);
  const [filteredNews, setFilteredNews] = useState([]);
  const [displayedNews, setDisplayedNews] = useState([]);
  const [loadMoreCount, setLoadMoreCount] = useState(8);
  const [loading, setLoading] = useState(false);

  // Initialize data on component mount
  useEffect(() => {
    const fetchArticles = async () => {
      setLoading(true);
      try {
        const res = await axios.get(`${API_URL_All}/api/news`, {
          params: { category: "nguon-hang" },
        });
        const mapped = (res.data || []).map((item) => ({
          ...item,
          image: item.imageUrl || newsImage1,
          date: item.publishDate || item.date || "",
          category: item.categorySlug || item.category || "",
          categoryLabel: item.category || item.categoryLabel || "",
        }));
        setNewsData(mapped);
        setFilteredNews(mapped);
        setDisplayedNews(mapped.slice(0, loadMoreCount));
      } catch (err) {
        console.error("Error loading source news", err);
      } finally {
        setLoading(false);
      }
    };

    fetchArticles();
  }, [loadMoreCount]);

  const filterNews = (query = searchQuery) => {
    let filtered = newsData;

    // Filter by search query
    if (query.trim()) {
      filtered = filtered.filter(
        (news) =>
          news.title.toLowerCase().includes(query.toLowerCase()) ||
          (news.excerpt || "").toLowerCase().includes(query.toLowerCase())
      );
    }

    setFilteredNews(filtered);
    setDisplayedNews(filtered.slice(0, loadMoreCount));
  };

  const handleSearch = () => {
    filterNews(searchQuery);
  };

  const handleSearchKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  const handleLoadMore = () => {
    const newCount = displayedNews.length + 8;
    setDisplayedNews(filteredNews.slice(0, newCount));
  };

  return (
    <div className="news-section">
      <Header />
      <Banner
        title="Nguồn hàng"
        backgroundImage={backgroundImage}
        breadcrumb={
          <>
            <Link to={"/"} className="text-white p-2">
              Trang chủ
            </Link>
            <span>{">"}</span>
            <Link to={"/news"} className="text-white p-2">
              Tin tức
            </Link>
            <span>{">"}</span>
            <Link to={"/source-news"} className="text-white p-2">
              Nguồn hàng
            </Link>
          </>
        }
      />

      <div className="container-fluid pb-5" style={{ background: "#F2F4F7" }}>
        <div className="container pt-4 pt-md-5">
          <div className="search-section row align-items-center justify-content-between">
            <div className="col-md-8 mb-3 mb-md-0">
              <div className="input-group search-box">
                <input
                  type="text"
                  className="form-control text-dark"
                  placeholder="Tìm kiếm thông tin nguồn hàng"
                  aria-label="Tìm kiếm thông tin nguồn hàng"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  onKeyDown={handleSearchKeyDown}
                />
                <button
                  className="btn search-btn"
                  type="button"
                  onClick={handleSearch}
                >
                  <IoSearchSharp size={20} />
                </button>
              </div>
            </div>
            <div className="col-md-4 d-flex justify-content-end">
              <button
                className="btn search-news-btn"
                onClick={handleSearch}
              >
                TÌM KIẾM TIN TỨC
              </button>
            </div>

          <div className="news-lists pt-3 pt-md-5">
            <div className="tat-ca-tin-tuc">
              <h3>Thông tin nguồn hàng</h3>

              {loading ? (
                <div className="d-flex justify-content-center py-5">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : (
                <>
                  <div className="news-grid row">
                    {displayedNews.map((news) => (
                      <div
                        key={news.id}
                        className="col-12 col-md-6 col-lg-3 mb-4"
                      >
                        <NewsCard news={news} isLarge={false} isNewsAll={true} />
                      </div>
                    ))}
                  </div>

                  {displayedNews.length < filteredNews.length && (
                    <div className="text-center mt-4">
                      <button className="load-more-btn" onClick={handleLoadMore}>
                        Xem thêm
                      </button>
                    </div>
                  )}

                  {filteredNews.length === 0 && (
                    <div className="text-center mt-4">
                      <p className="text-muted">Không tìm thấy tin tức phù hợp.</p>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* <NewsQuoteBanner /> */}
      <CTASection />
      <Footer />
    </div>
    </div>
  );
};

export default SourceNews;
